'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { useUsers } from '@/domain/user/hooks';
import { type UserBrief } from '@/domain/user/types';
import { useAuth } from '@/hooks/useAuth';
import { Autocomplete } from '@andritzot/metris-web-ui/inputs/autocomplete';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface ParticipantsFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function ParticipantsField({ viewOnly, control }: Readonly<ParticipantsFieldProps>) {
  const { user } = useAuth();
  const { data: users } = useUsers({ enabled: !!user });

  return (
    <Box sx={{ py: 0.75 }}>
      <Controller
        name="participants"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FieldActionsWrapper copyValue={(value ?? []).map((u) => u.name).join(', ')}>
            <Autocomplete<UserBrief, true, false, false>
              multiple
              value={value ?? []}
              onChange={(_, newValue) => onChange(newValue)}
              options={users ?? []}
              getOptionLabel={(u) => u.name}
              getOptionKey={(u) => u.idUser}
              isOptionEqualToValue={(opt, v) => opt.idUser === v.idUser}
              label="Participants"
              placeholder="Search users..."
              disabled={viewOnly}
              fullWidth
              size="small"
              renderInput={(params) => <TextField {...params} label="Participants" multiline minRows={3} />}
            />
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
